import { KEYCODE } from '../constants';

export default class Nav {
  constructor(el) {
    this.el = el;

    if (!this.el) {
      return;
    }

    // Toggle visibility of subnav items
    [...this.navLinks].forEach((link) => {
      link.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          let expand =
            link.getAttribute('aria-expanded') == 'true' ? false : true;

          [...this.navLinks].forEach((nav) =>
            nav.parentNode.classList.remove('on-top-now')
          );
          // Hide secondary nav
          if (!expand) {
            [...this.secondaryNavLinks].forEach((link) =>
              link.setAttribute('aria-expanded', false)
            );
            [...this.tertiaryNavLinks].forEach((nav) =>
              nav.setAttribute('aria-expanded', false)
            );
            [...this.tertiaryNavs].forEach((nav) =>
              nav.setAttribute('aria-hidden', true)
            );
            this.el
              .querySelector('.c-nav-primary')
              .classList.remove('c-nav-primary--bg');
          } else {
            this.el
              .querySelector('.c-nav-primary')
              .classList.add('c-nav-primary--bg');

            link.parentNode.classList.add('on-top-now');
          }

          this._handleNavState(this.navLinks, link, this.secondaryNavs, expand);
        },
        true
      );
    });

    this.hamboogie.addEventListener(
      'click',
      (e) => {
        this.el
          .querySelector('.c-nav-primary__menu')
          .classList.toggle('c-nav-primary__menu--vis');
        this.el
          .querySelector('.c-nav-secondary')
          .classList.toggle('c-nav-secondary--vis');
        this.el
          .querySelector('.c-nav-primary__hamburger')
          .classList.toggle('c-nav-primary__hamburger--active');

        document.querySelector('body').classList.toggle('posfixed');

        this.el.classList.toggle(
          'vh100'
        ); /* Try changing element this is added to */

        /* What is the difference between vh100 and vis? */
      },
      true
    );

    [...this.secondaryNavLinks].forEach((link) => {
      link.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          let expand =
            link.getAttribute('aria-expanded') == 'true' ? false : true;

          this._handleNavState(
            this.secondaryNavLinks,
            link,
            this.tertiaryNavs,
            expand
          );
        },
        true
      );
    });

    [...this.tertiaryNavLinks].forEach((link) => {
      link.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          let expand =
            link.getAttribute('aria-expanded') == 'true' ? false : true;

          this._handleNavState(
            this.tertiaryNavLinks,
            link,
            this.tertiaryNavs,
            expand
          );

          this._handleTertiaryNavDesc(link, expand);
        },
        true
      );
    });

    [...this.backButton].forEach((button) => {
      button.addEventListener(
        'click',
        (e) => {
          [...this.secondaryNavLinks].forEach((link) =>
            link.setAttribute('aria-expanded', false)
          );
          button.parentElement.parentElement.setAttribute('aria-hidden', true);
        },
        false
      );
    });

    document.addEventListener('keydown', this._handleKeyDown.bind(this), false);

    window.addEventListener(
      'resize',
      () => {
        this._updateNavHeight();
      },
      true
    );
  }

  get navLinks() {
    return this.el.querySelectorAll('[data-js-nav-link-level1]');
  }

  get hamboogie() {
    return this.el.querySelector('[data-js-hamburger]');
  }

  get secondaryNavs() {
    return this.el.querySelectorAll('[data-js-nav-secondary]');
  }

  get secondaryNavLinks() {
    return this.el.querySelectorAll('[data-js-nav-secondary-link]');
  }

  get tertiaryNavs() {
    return this.el.querySelectorAll('[data-js-nav-tertiary]');
  }

  get tertiaryNavLinks() {
    return this.el.querySelectorAll('[data-js-nav-tertiary-link]');
  }

  get backButton() {
    return this.el.querySelectorAll('[data-js-nav-back]');
  }

  _expanded() {
    return document.querySelectorAll('[data-js-nav] [aria-expanded="true"]')
      .length;
  }

  _handleNavState(links, link, navs, expanded) {
    [...links].forEach((navLink) =>
      navLink.setAttribute('aria-expanded', false)
    );
    link.setAttribute('aria-expanded', expanded);

    // Open nav
    [...navs].forEach((nav) => nav.setAttribute('aria-hidden', true));
    link.nextElementSibling.setAttribute('aria-hidden', !expanded);

    this._updateNavHeight(link);
  }

  _handleTertiaryNavDesc(link, expanded) {
    let parent = link.closest('.c-nav-primary__menu-lvl3');

    if (parent) {
      parent.classList.toggle(
        'c-nav-primary__menu-lvl3--has-open-child',
        expanded
      );
    }
  }

  _handleKeyDown(evt) {
    const keyCode = evt.which;

    // If menu open on ESC, close
    if (keyCode === KEYCODE.ESC && this._expanded()) {
      this._closeNav();
    }
  }

  _handleScroll() {
    let thisvar = this;

    if (this._expanded()) {
      window.addEventListener('scroll', function () {
        console.log('this needs to stop');
        thisvar._closeNav();
      });
    }
  }

  _updateNavHeight(link) {
    // Find the open menu if this wasn't triggered by a click
    link =
      link ||
      this.el.querySelector(
        '#menu-main-nav > .menu-item > [aria-expanded="true"]'
      );

    if (!link) return;

    // Get all open menus
    const rootMenu = link.closest('#menu-main-nav > .menu-item');
    const openMenus = rootMenu.querySelectorAll(
      '[aria-expanded="true"] + [aria-hidden="false"]'
    );
    let largestMenu = 0;

    // Find the largest open menu, accounting for the padding of absolutely positioned elements
    openMenus.forEach(function (menu, i) {
      const padding = i === 0 ? 50 : 134;
      const menuHeight = menu.offsetHeight + padding;

      largestMenu = Math.max(largestMenu, menuHeight);
    });

    // Set the nav height CSS variable to the largest open menu
    const root = document.documentElement;
    root.style.setProperty('--nav-height', largestMenu + 'px');
  }

  _closeNav() {
    [...this.navLinks].forEach((navLink) =>
      navLink.setAttribute('aria-expanded', false)
    );
    [...this.secondaryNavs].forEach((nav) =>
      nav.setAttribute('aria-hidden', true)
    );
    [...this.secondaryNavLinks].forEach((navLink) =>
      navLink.setAttribute('aria-expanded', false)
    );
    [...this.tertiaryNavs].forEach((nav) =>
      nav.setAttribute('aria-hidden', true)
    );
    [...this.tertiaryNavLinks].forEach((navLink) =>
      navLink.setAttribute('aria-expanded', false)
    );

    this.el
      .querySelector('.c-nav-primary')
      .classList.remove('c-nav-primary--bg');
  }
}
